import { getFirstSectionId } from "utils/getFirstSectionId";
import { scrollToSection } from "utils/scrollTo";

export const getFirstContentElement = () => {
  if (typeof window === "undefined") return;

  let mastheadSeachBox = document.getElementById("mastheadSeachBox");
  if (mastheadSeachBox) return mastheadSeachBox;
  else {
    let productHeroScroll = document.getElementById("productHeroScroll");
    if (productHeroScroll) return productHeroScroll;
    else {
      let backBreadcrumbButton = document.getElementById(
        "backBreadcrumbButton"
      );
      if (backBreadcrumbButton) return backBreadcrumbButton;
      else {
        let firstSectionElementId = getFirstSectionId();
        scrollToSection(firstSectionElementId);
        let firstSectionElement = document.getElementById(
          firstSectionElementId
        );
        if (firstSectionElement) return firstSectionElement;
      }
    }
  }

  return;
};
